import { createSlice } from '@reduxjs/toolkit'


console.log(process.env);

const img_http = process.env.REACT_APP_IMG_HTTP!
const twUrl = process.env.REACT_APP_VUETIANWAA_BASE_URL!
console.log(twUrl,'--twUrl--',img_http);

const configSlice = createSlice({
  name: 'configs',
  initialState: {
    img_http,
    twUrl,
  },
  reducers: {}
})

export default configSlice.reducer
